const TIME_ZONE = 'Asia/Tokyo';
const DATE_FORMAT = 'YYYY/MM/DD';
const DATE_FORMAT_DOWNLOAD = 'YYYYMMDD';
const DATE_TIME_FORMAT_WITHOUT_SECOND = 'YYYY/MM/DD HH:mm';
const DATE_FORMAT_JP = 'YYYY年MM月DD日';
const DATE_FORMAT_JP_FULL = 'YYYY年MM月DD日 HH:mm:ss';
const DATE_TIME_FORMAT_JP_WITHOUT_SECOND = 'YYYY年MM月DD日HH時mm分';
const DATE_FORMAT_DASH = 'YYYY-MM-DD';

const PRINT_DATE_BIG1_FORMAT = 'YYYY.MM.DD ddd.';
const PRINT_DATE_BIG1_FORMAT_PERIOD = 'YYYY.MM.DD ddd -';
const PRINT_DATE_FORMAT_MONTH = 'MMM.';
const PRINT_DATE_FORMAT_DAY = 'Do.';

export {
  DATE_FORMAT,
  DATE_FORMAT_DASH,
  DATE_FORMAT_DOWNLOAD,
  DATE_FORMAT_JP,
  DATE_FORMAT_JP_FULL,
  DATE_TIME_FORMAT_JP_WITHOUT_SECOND,
  DATE_TIME_FORMAT_WITHOUT_SECOND,
  PRINT_DATE_BIG1_FORMAT,
  PRINT_DATE_BIG1_FORMAT_PERIOD,
  PRINT_DATE_FORMAT_DAY,
  PRINT_DATE_FORMAT_MONTH,
  TIME_ZONE,
};
